import { prop } from 'ramda'
import { sortClasses } from 'app/common/lib/sort'

export const sortByTitle = sortClasses<{ title: string }>('up', prop('title'))

export const emptyArray = []
